module.exports = __webpack_public_path__ + "static/media/loja1.85043593.jpg";